import React, { useEffect, useState } from "react";  

import {  
    DashboardAnimation,
    DashboardTitle,
    DashboardText,
    ContentFilter,
    ContentTableAction
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import Select from "components/Form/Select";
import BasicTable from "components/Form/Table";
import Button from "components/Form/Button";
import { Read } from "services/fundsAndAssetsReports";
import { exposeStrapiError, parseStrapiImage } from "utils";

export default function DashboardActiveAndFounds(){  

    // const reportOptions = [
    //     { id:1, title:'Spectra I' },
    //     { id:2, title:'Spectra II' },
    //     { id:3, title:'Spectra III' },
    //     { id:4, title:'Spectra IV' }
    // ]

    const columns = [
        { title:'Período', ref:'period' },
        { title:'Data', ref:'date' },
        { 
            ref: 'id', 
            title: 'Visualizar', 
            renderCell: ({ row }) => !row?.file?.url ? null : <>
                <ContentTableAction>
                    <Button primary nospace small onClick={() => window.open(parseStrapiImage(row.file.url), '')}>
                        Abrir documento
                    </Button>
                </ContentTableAction>
            </>  
        },
    ]
    
    // const rows = [
    //     { period:'1T/2018', date: '20/12/2022', id:1 },
    //     { period:'2T/2018', date: '20/12/2022', id:2 },
    //     { period:'3T/2018', date: '20/12/2022', id:3 },
    //     { period:'4T/2018', date: '20/12/2022', id:4 },
    //     { period:'1T/2019', date: '20/12/2022', id:5 },
    //     { period:'2T/2019', date: '20/12/2022', id:6 }
    // ]
    
    const [rows, setRows] = useState([ ])
    const [loading, setLoading] = useState(false)
    const [reportOptions, setReportOptions] = useState([ ])
    const [filterReportOptions, setFilterReportOptions] = useState(0)

    const init = async () => {
        setLoading(true)
        const result = await Read()
        setRows(!(result && !exposeStrapiError(result) && result.length) ? [] : result.map(item => ({
            ...item
        })))
        setReportOptions(!(result && result.length) ? [] : result.map(item => ({
            ...item.fund, title: item?.fund?.name ?? ''
        })).reduce((p,c) => p.map(m=>m.id).includes(c.id) ? p : [...p, c], []))
        setLoading(false)
    }

    const filterReports = fit => {
        return !filterReportOptions || fit?.fund?.id === filterReportOptions
    }

    useEffect(() => {
        init()
    }, [])

    return ( 
        <>
            <ContainerAuthenticated page={"reports/actives-and-founds"}> 
                <Row>
                    {/* <Col sm={12} md={9} xl={5}> */}
                    <Col sm={12} xl={5}>
                        <DashboardTitle>
                            Fundos e ativos
                        </DashboardTitle>

                        <ContentFilter>
                            <Select placeholder={"Fundo"} options={reportOptions} value={filterReportOptions} onChange={setFilterReportOptions} />
                        </ContentFilter> 

                        {/* 
                            <DashboardText>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ut congue nisl. Duis lobortis ante vitae hendrerit efficitur. Quisque dolor magna, efficitur et nunc id, pretium porta mauris. Integer vel lobortis risus. Duis consectetur ac ante at ullamcorper. Nullam luctus sollicitudin odio, eu gravida lorem efficitur ac. Nam pulvinar consequat cursus. Maecenas convallis sagittis erat, at tristique lectus pharetra et. In eget metus nisl. Maecenas orci ipsum, sagittis non erat eleifend, dignissim suscipit mi. Ut a tellus quis enim pellentesque fringilla. Sed in malesuada felis, eget volutpat neque.
                            </DashboardText>  
                        */}

                        <BasicTable loading={loading} columns={columns} rows={rows.filter(filterReports)} />

                    </Col>
                    <Col></Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}